module.exports = __webpack_public_path__ + "media/applicants/icon-shopping@2x-d5a233cc.png";